import * as types from './constants';

const initialState = {
  results: [],
  isFetching: false,
  didInvalidate: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {

    case types.REQUEST_SEARCH: return {
      ...state,
      isFetching: true
    };

    case types.RECEIVE_SEARCH: return {
      ...state,
      isFetching: false,
      didInvalidate: false,
      results: action.results
    };

    case types.CLEAR_SEARCH: return {
      ...state,
      results: []
    };

    default: return state;
  }
};

export default reducer;
